module.exports = __webpack_public_path__ + "img/s2-hx-9.c70075cc.png";